/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {manualDisableYield} from '../api'

export const useMutationManualDisableYield = createReactQueryMutationHook('manualDisableYield', manualDisableYield)
